import type { UseClaimPermissionsDeps } from '@/types/session/sessionTypes'
import { hasCapability } from '#shared/utils/capabilities'

export function useClaimPermissions(deps: UseClaimPermissionsDeps = {}) {
  const getUser = deps.getUser ?? (() => useSupabaseUser().value)

  const canDistribute = computed(() => hasCapability(getUser()?.app_metadata, 'distribution'))

  return {
    canDistribute,
  }
}
